import {
	SET_GROUPS,
	SET_GROUP,
	CLEAR_GROUPS,
	CLEAR_GROUP,
	ADD_GROUP,
	UPDATE_GROUP,
	REMOVE_GROUP,
} from './actionTypes';

export const group = (state = {}, action) => {
	switch (action.type) {
		case SET_GROUP:
			return action.payload;
		case UPDATE_GROUP:
			if (state._id.toString() !== action.payload._id.toString()) {
				return state;
			}

			// Otherwise, this is the one we want - return an updated value
			return {
				...state,
				...action.payload,
			};
		case CLEAR_GROUP:
			return {};
		default:
			return state;
	}
};

export default (state = [], action) => {
	switch (action.type) {
		case SET_GROUPS:
			return action.payload;
		case ADD_GROUP:
			return [...state, action.payload];
		case UPDATE_GROUP:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
					...action.payload,
				};
			});
		case REMOVE_GROUP:
			return state.map((item) => {
				if (item._id !== action.payload._id) {
					return item;
				}

				// Otherwise, this is the one we want - return an updated value
				return {
					...item,
				};
			});
		case CLEAR_GROUPS:
			return [];
		default:
			return state;
	}
};
